export default "__VITE_ASSET__C1bGL7XC__"